export { ImgSizeAttr } from './ImgSizeSpecs';
export { imageNodeName, addImageAction } from '../../markdown/Image/const';
